import React from "react";
import { cn } from "utils/cn";

export default function DashboardChartFrame({
  children,
  className,
  minWidthClass = "min-w-[620px] sm:min-w-0",
}) {
  return (
    <div className="-mx-2 overflow-x-auto px-2">
      <div className={cn(minWidthClass, className)}>{children}</div>
    </div>
  );
}
